import classesK from '../kalkulatori.module.css'
import classes from './dalembert.module.css'
import { useState } from 'react'
import InfoBar from '../redesign/components/InfoBar'
import ResultsSection from '../redesign/components/ResultsSection'
import add from '../images/add.svg'

const calculatorType = 'D alembert'
const Dalembert = () => {
  const [showInputArea, setShowInputArea] = useState(true)
  const initialValues = {
    ulogArr: new Array(21).fill(''),
    kvotaArr: new Array(21).fill(''),
    dobitakArr: new Array(21).fill(0),
    trenutnoStanjeArr: new Array(21).fill(0),
    prolazUpisArr: new Array(21).fill(''),
    isActive: [true, ...new Array(20).fill(false)],
    totalStanje: 0,
  }

  const [games, setGames] = useState([{ id: 1 }])
  const [data, setData] = useState({ values: initialValues })

  const calculateAll = (values) => {
    if (
      !values ||
      !values.ulogArr ||
      !values.kvotaArr ||
      !values.prolazUpisArr
    ) {
      return values
    }

    const ulogArr = values.ulogArr.map((v) => Number(v) || 0)
    const kvotaArr = values.kvotaArr.map((v) => Number(v) || 0)
    const prolazUpisArr = values.prolazUpisArr

    // Dobitak
    const dobitakArr = ulogArr.map((ulog, index) => ulog * kvotaArr[index])

    // Trenutno stanje
    const trenutnoStanjeArr = dobitakArr.map((dobitak, index) => {
      const prolaz = prolazUpisArr[index]?.toLowerCase()
      if (prolaz === 'da') {
        return dobitak - ulogArr[index]
      } else if (prolaz === 'ne') {
        return -ulogArr[index]
      }
      return 0
    })

    // Sledeći ulog
    const nextUlog = trenutnoStanjeArr.map((stanje, index) => {
      const prolaz = prolazUpisArr[index]?.toLowerCase()
      const baseUlog = ulogArr[0] || 0

      if (prolaz === 'da') {
        let value = Math.abs(stanje) - baseUlog
        return value <= 0 ? baseUlog : value
      } else if (prolaz === 'ne') {
        let value = dobitakArr[index] - ulogArr[index] + baseUlog
        return value <= 0 ? baseUlog : value
      }

      return 0
    })

    // Popuni sledeći ulog u array
    const updatedUlogArr = [...ulogArr]
    for (let i = 0; i < nextUlog.length - 1; i++) {
      if (!updatedUlogArr[i + 1]) {
        updatedUlogArr[i + 1] = nextUlog[i]
      }
    }

    // Ukupno trenutno stanje
    const validStanja = trenutnoStanjeArr.filter((v) => !isNaN(v))
    const totalStanje = validStanja.reduce((acc, curr) => acc + Number(curr), 0)

    return {
      ulogArr: updatedUlogArr,
      kvotaArr,
      prolazUpisArr,
      dobitakArr,
      trenutnoStanjeArr,
      totalStanje,
      isActive: prolazUpisArr.map((v) => v.toLowerCase() === 'da'),
    }
  }

  const addSeries = () => {
    setData((prevData) => {
      const prevValues = prevData.values

      return {
        values: {
          ...prevValues,
          ulogArr: [...prevValues.ulogArr, ''],
          kvotaArr: [...prevValues.kvotaArr, ''],
          prolazUpisArr: [...prevValues.prolazUpisArr, ''],
          dobitakArr: [...prevValues.dobitakArr, ''],
          trenutnoStanjeArr: [...prevValues.trenutnoStanjeArr, ''],
          isActive: [...prevValues.isActive, false],
          totalStanje: prevValues.totalStanje,
        },
      }
    })

    setGames((prev) => [...prev, { id: prev.length + 1 }])
  }

  const clearFields = () => {
    const resetValues = {
      ulogArr: new Array(21).fill(''),
      kvotaArr: new Array(21).fill(''),
      dobitakArr: new Array(21).fill(0),
      trenutnoStanjeArr: new Array(21).fill(0),
      prolazUpisArr: new Array(21).fill(''),
      isActive: [true, ...new Array(20).fill(false)],
      totalStanje: 0,
    }

    setShowInputArea(true)
    setData({ values: resetValues })
    setGames([{ id: 1 }])
  }

  return (
    <div className={classesK.container}>
      <InfoBar calculatorType={calculatorType} onRefresh={clearFields} />
      <div className={classesK.contentContainer}>
        {showInputArea && (
          <>
            <div className={classesK.sectionTitle}>Ukupno trenutno stanje</div>
            <ResultsSection
              subtitle={'Prikaz trenutnog stanja'}
              names={['Tvoja trenutna banka']}
              results={[data.values.totalStanje]}
            />
            {games.map((game, index) => (
              <div className={classes.gameContainer} key={game.id}>
                <div className={classes.gameTitle}>Igra br. {game.id}</div>
                <div className={classes.inputContainer}>
                  {index === 0 ? (
                    <div className={classesK.oddsContainer}>
                      <span>Upiši ulog</span>
                      <input
                        type='number'
                        value={data.values.ulogArr[index]}
                        onChange={(e) => {
                          const updatedUlog = [...data.values.ulogArr]
                          updatedUlog[index] = e.target.value
                          const newValues = {
                            ...data.values,
                            ulogArr: updatedUlog,
                          }
                          setData({ values: calculateAll(newValues) })
                        }}
                        step='1'
                        min='1'
                        rows={1}
                        style={{ width: '100%' }}
                      />
                    </div>
                  ) : (
                    <ResultsSection
                      names={['Ulog']}
                      results={[Number(data.values.ulogArr[index]).toFixed(2)]}
                    />
                  )}

                  <div className={classes.oddsCalcWrapper}>
                    <div className={classes.inputsWrapper}>
                      <div className={classes.oddsContainer}>
                        <span>Upiši kvotu</span>
                        <input
                          type='number'
                          step='0.1'
                          min='0.1'
                          value={data.values.kvotaArr[index]}
                          onChange={(e) => {
                            const updatedKvota = [...data.values.kvotaArr]
                            updatedKvota[index] = e.target.value
                            const newValues = {
                              ...data.values,
                              kvotaArr: updatedKvota,
                            }
                            setData({ values: calculateAll(newValues) })
                          }}
                          style={{ width: '100%' }}
                        />
                      </div>

                      <div className={classes.oddsContainer}>
                        <span>Upiši prolaz (da/ne)</span>
                        <input
                          type='text'
                          value={data.values.prolazUpisArr[index]}
                          onChange={(e) => {
                            const updatedProlaz = [...data.values.prolazUpisArr]
                            updatedProlaz[index] = e.target.value
                            const newValues = {
                              ...data.values,
                              prolazUpisArr: updatedProlaz,
                            }
                            setData({ values: calculateAll(newValues) })
                          }}
                          style={{ width: '100%' }}
                        />
                      </div>
                    </div>

                    <ResultsSection
                      names={['Obračunski podaci', 'Dobitak u ovoj seriji']}
                      rows={2}
                      results={[
                        Number(data.values.trenutnoStanjeArr[index]).toFixed(2),
                        Number(data.values.dobitakArr[index]).toFixed(2),
                      ]}
                      allowNegative={true}
                    />
                  </div>
                </div>
              </div>
            ))}
          </>
        )}
        {games.length < 25 && (
          <div className={classesK.addMore}>
            <button onClick={addSeries} className={classesK.addButton}>
              <img src={add} height={18} width={18} alt='image' />
              Dodaj još jednu seriju
            </button>
          </div>
        )}
      </div>
    </div>
  )
}
export default Dalembert
